import * as ko from 'knockout'
import '@classic/AppUtils/Framework/CustomBindings/StickyBinding'
import ObservableRacePage from '@classic/Betting-v2/Model/Observables/ObservableRacePage'
import { BettingInformation } from '@classic/Betting-v2/Model/BettingInformation'
import template from './starters.tpl.html'
import { StartersPageViewModel } from './StartersPageViewModel'

if (!ko.components.isRegistered('starters-page')) {
  ko.components.register('starters-page', {
    viewModel: {
      createViewModel: (params: {
        raceInformation: ObservableRacePage
        bettingInformation: BettingInformation
      }) => {
        const viewModel = new StartersPageViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
